/**
 * Converts a binary string into an array of integers.
 * @function convertBinaryStringToArray
 * @param {string} binaryString - The binary string to be converted.
 * @returns {number[]} An array of integers representing the binary string.
 */
export function convertBinaryStringToArray(binaryString: string): number[] {
    return binaryString.split("").map((x) => parseInt(x));
}
